export * from './invoke-capability.message';
export * from './invoke-function.message';
export * from './set-component-props.message';
export * from './set-component-state.message';
export * from './nav-operation.message';
export * from './nc-modal.message';
import { INVOKE_CAPABILITY } from './invoke-capability.message';
import { INVOKE_FUNCTION } from './invoke-function.message';
import { SET_COMPONENT_PROPS } from './set-component-props.message';
import { SET_COMPONENT_STATE } from './set-component-state.message';

// NOTE: Messages below are intended for use with `iframeable`
export const messages = {
  INVOKE_CAPABILITY,
  SET_COMPONENT_PROPS,
  SET_COMPONENT_STATE,
  INVOKE_FUNCTION
};
export const isValidMessage = msg => !!msg.payload && typeof msg.payload === 'object';